import { Edit as CatalogEdit } from './Edit';

export default CatalogEdit;
